module.exports = __webpack_public_path__ + "img/kmbjgt.d12d472f.png";